import { DateTime } from 'luxon'
import { LANGUAGE, LANGUAGE_LOCALE } from '../locales/config'
import { DateTime as DateTimeProto } from 'patient-api-lib'

export function getLocale(preferredLanguage: string) {
  if (!preferredLanguage) return navigator.language

  return preferredLanguage === LANGUAGE.SV
    ? LANGUAGE_LOCALE.SV
    : LANGUAGE_LOCALE.EN
}

export function formatDate(date: Date | null, language = 'sv-SE') {
  if (!date) return ''

  return DateTime.fromJSDate(date).toFormat('d LLL HH:mm', {
    locale: getLocale(language),
  })
}

export function createDateFromObject(dateObj?: DateTimeProto.AsObject) {
  if (!dateObj) return DateTime.local()

  return DateTime.local(
    dateObj?.year,
    dateObj?.month,
    dateObj?.day,
    dateObj?.hours,
    dateObj?.minutes,
    {
      zone: dateObj?.timeZone?.id,
    }
  )
}

export function shiftClientTimeZone(date: Date) {
  return new Date(
    date.getTime() - new Date().getTimezoneOffset() * 60000
  ).toISOString()
}
